import './dateTransform';

import { date, number, object, string } from 'yup';

const mortgageCalcValidation = (errorMessages, kind) => {
  const fields = {
    ...(kind === 'anschlussfinanzierung'
      ? {
          endDateInterestRate: date()
            .dateTransform()
            .required(errorMessages.endDateInterestRate.required)
            .typeError(errorMessages.endDateInterestRate.required)
            .default(''),
        }
      : {}),
    ...(['immobilien', 'neubau', 'modernisierung', 'kapitalbeschaffung', 'anschlussfinanzierung'].includes(kind)
      ? { kind: string().trim().required(errorMessages.kind.required).default('') }
      : {}),
    propertyUse: string().trim().required(errorMessages.propertyUse.required).default(''),
    postcode: string()
      .trim()
      .required(errorMessages.postcode.required)
      .min(5, errorMessages.postcode.tooShort)
      .max(5, errorMessages.postcode.tooLong)
      .default(''),
    buyingPrice: number()
      .required(errorMessages.buyingPrice.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .default(undefined),
    equity: number()
      .required(errorMessages.equity.required)
      .integer(errorMessages.isInt)
      .typeError(errorMessages.isInt)
      .default(undefined),
    employment: string().required(errorMessages.employment.required).trim().default(''),
    nominalInterestRateFixationInYears: string()
      .trim()
      .required(errorMessages.nominalInterestRateFixationInYears.required)
      .default(''),
    repayment: string().trim().required(errorMessages.repayment.required).default(''),
    estateId: string().trim().default(''),
  };

  return object().shape(fields);
};

export default mortgageCalcValidation;
